/*
 * Copyright (c) 2008-2026 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */
export const INHERITABLE_CONFIG_KEYS = Object.freeze({
  ACCREDITATION_REQUIRED_FOR_VOTING: "accreditationRequiredForVoting",
  ACCREDITATION_TEXT_FOR_VOTING: "accreditationTextForVoting",
  ENABLE_ACCREDITATION: "enableAccreditation",
  ENABLE_PROXY_CHAINS: "enableProxyChains",
})

export const TENANT_KEYS_TO_LOAD = Object.values(INHERITABLE_CONFIG_KEYS)
export const MEETING_KEYS_TO_LOAD = Object.values(INHERITABLE_CONFIG_KEYS)
